export default __webpack_public_path__ + "static/media/earnings.471d537e.png";